import { Box, Typography } from '@mui/material'

export const MyBank = () => {
    return (
         <Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center">
            <Box bgcolor="#f39c12" padding="15px 30px" borderRadius={5} boxShadow={1}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '5px', textAlign: 'center' }}>
                    🚀 Feature Coming Soon!
                </Typography>
                <Typography variant="body2">
                    We're working hard on an exciting new feature that will be available soon. Stay tuned for updates!
                </Typography>
            </Box>
        </Box>
    )
}
